export interface PlessoResponse {
    id: string;
    nome: string;
    IdIstituto: string;
    stato: string;
}